module.exports = __webpack_public_path__ + "static/media/prop-12@2x-thumb.09d3242d.webp";